import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { Observable, from, of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { GetApiService } from '../get-api.service';

@Injectable({
  providedIn: 'root',
})
export class AccessGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private usersService: GetApiService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    if (state.url.includes('access-denied')) {
      return of(true);
    }
  
    console.log('[AccessGuard] canActivate triggered');
  
    return from(this.authService.checkAndSetActiveAccounts()).pipe(
      switchMap((account) => {
        if (!account) {
          this.authService.login();
          return of(false);
        }
  
        console.log('[AccessGuard] Calling AD group API');
  
        return this.usersService.getAdgroupExtraction().pipe(
          map((res: any) => {
            console.log('[AccessGuard] API response:', res);
  
            if (res?.allowed === true) {
              return true;
            }
  
            console.log('[AccessGuard] Access denied, redirecting');
            this.router.navigateByUrl('/access-denied');
            return false;
          }),
          catchError((err) => {
            console.error('[AccessGuard] API error', err);
            this.router.navigateByUrl('/access-denied');
            return of(false);
          })
        );
      })
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
